import React, { useState } from "react";
import "./CreateUserModal.css";
import { createUser, user } from "../services/api";

const UserModel = ({ closeModal, updateUserData }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createUser(name, email, password, mobile);
      console.log(response);

      if (response.status === 201) {
        console.log("User created successfully:");
        updateUserData();
        closeModal();
      } else {
        console.log("error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="form-container">
      <div className="back-arrow" onClick={closeModal}>
        &#x2190;
      </div>
      <h1>Create New User!</h1>
      <p>Start your DanDun's vendor journey today!</p>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="full-name" className="label">
              Full Name
            </label>
            <div className="input-container">
              <input
                type="text"
                id="full-name"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <span className="input-icon">&#128100;</span>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="email-id" className="label">
              Email ID
            </label>
            <div className="input-container">
              <input
                type="email"
                id="email-id"
                placeholder="xyz@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <span className="input-icon">&#x2709;</span>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="email-id" className="label">
              Mobile No
            </label>
            <div className="input-container">
              <input
                type="number"
                id="Mobile Number"
                placeholder="98765432"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                required
                className="no-arrows"
              />
              <span className="input-icon">&#x2709;</span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="password" className="label">
              Password
            </label>
            <div className="input-container">
              <input
                type="password"
                id="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span className="input-icon">&#128274;</span>
            </div>
          </div>
        </div>
        <button type="submit" className="create-button-popup">
          Create
        </button>
      </form>
    </div>
  );
};

export default UserModel;
